import { render, staticRenderFns } from "./lookGroup.vue?vue&type=template&id=b74e803c&scoped=true&"
import script from "./lookGroup.vue?vue&type=script&lang=js&"
export * from "./lookGroup.vue?vue&type=script&lang=js&"
import style0 from "./lookGroup.vue?vue&type=style&index=0&id=b74e803c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b74e803c",
  null
  
)

export default component.exports